import { RouteConfig } from 'vue-router';

const CollaborationCasesRoute: RouteConfig[] = [
  {
    path: '/CollaborationCases/index.html',
    name: 'CollaborationCasesIndex',
    meta: { title: '合作案例' },
    component: () => import('@/views/CollaborationCases/index.vue'),
  },
  {
    path: '/CollaborationCasesDetail/:caseIndex',
    name: 'CollaborationCasesDetail',
    meta: { title: '案例详情' },
    component: () => import('@/views/CollaborationCases/detail.vue'),
  },
];

export { CollaborationCasesRoute };
